export default __webpack_public_path__ + "static/img1-85a6784e2ee7e1b307783c10d0865934.jpg";